var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.42578 19.5506C10.4297 17.0363 15 10.9424 15 7.51946C15 3.36809 11.6406 0 7.5 0C3.35938 0 0 3.36809 0 7.51946C0 10.9424 4.57031 17.0363 6.57422 19.5506C7.05469 20.1498 7.94531 20.1498 8.42578 19.5506ZM7.5 5.01297C8.16304 5.01297 8.79893 5.27705 9.26777 5.74711C9.73661 6.21716 10 6.8547 10 7.51946C10 8.18422 9.73661 8.82176 9.26777 9.29181C8.79893 9.76187 8.16304 10.0259 7.5 10.0259C6.83696 10.0259 6.20107 9.76187 5.73223 9.29181C5.26339 8.82176 5 8.18422 5 7.51946C5 6.8547 5.26339 6.21716 5.73223 5.74711C6.20107 5.27705 6.83696 5.01297 7.5 5.01297Z",
    fill: "#0ABAB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.ac68e3654a3e031e178a87ca0cc0c820.svg";
export { ForwardRef as ReactComponent };